export default __webpack_public_path__ + "static/media/health-symptoms_icon.2454d9d3.svg";